/**
 * Created by neo on 17.10.22.
 */
import { makeAutoObservable } from 'mobx';

export type ShopUrlResponse = {
  shopUrl: string;
  baseUrl: string;
  refreshLoginUrl: string;
  expiresAt: Date;
};

export function createShopUrlResponse(json?: Partial<ShopUrlResponse>): ShopUrlResponse {
  return makeAutoObservable({
    shopUrl: json?.shopUrl ?? '',
    baseUrl: json?.baseUrl ?? '',
    refreshLoginUrl: json?.refreshLoginUrl ?? '',
    expiresAt: json?.expiresAt ? new Date(json.expiresAt as any) : new Date(),
  });
}
